/**
 * Card Destination Gutenberg Block
 * --------------------------------
 * A clickable destination card with image, title, description, and link.
 * Ideal for travel or category listings.
 */

if (window.wp && window.wp.ajax) {

    const { registerBlockType } = window.wp.blocks;

    const {
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;

    const {
        PanelBody,
        IconButton,
        TextControl,
        TextareaControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-destination', {

        /* Block metadata */
        title: 'Card Destination',
        description: 'A clickable destination card with image, title, description, and link.',
        icon: 'location-alt',
        category: 'custom-cards',
        example: {},

        /* Block attributes */
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: '',
            },
            alt: {
                type: 'string',
                default: '',
            },
            title: {
                type: 'string',
                default: '',
            },
            description: {
                type: 'string',
                default: '',
            },
            viewMore: {
                type: 'string',
                default: 'Pogledajte ponudu',
            },
        },

        /* Editor UI */
        edit({ attributes, setAttributes }) {

            const { link, image, alt, title, description } = attributes;

            const onLinkChange = (value) => setAttributes({ link: value });
            const onAltChange = (value) => setAttributes({ alt: value });
            const onTitleChange = (value) => setAttributes({ title: value });
            const onDescriptionChange = (value) => setAttributes({ description: value });

            const onSelectImage = (media) => {
                if (media && media.sizes && media.sizes.full) {
                    setAttributes({ image: media.sizes.full.url });
                }
            };

            return (
                <>
                    {/* Sidebar settings */}
                    <InspectorControls>
                        <PanelBody title="Card Settings">

                            <MediaUpload
                                onSelect={onSelectImage}
                                type="image"
                                value={image}
                                render={({ open }) => (
                                    <IconButton
                                        onClick={open}
                                        icon="upload"
                                        className="editor-media-placeholder__button is-button is-default is-large"
                                    >
                                        Select Background Image
                                    </IconButton>
                                )}
                            />

                            <p><strong>Alt text for image</strong></p>
                            <TextControl
                                value={alt}
                                onChange={onAltChange}
                            />

                            <p><strong>Destination URL (e.g. /putovanja)</strong></p>
                            <TextControl
                                value={link}
                                onChange={onLinkChange}
                            />

                            <p><strong>Card Title</strong></p>
                            <TextControl
                                value={title}
                                onChange={onTitleChange}
                            />

                            <p><strong>Card Description</strong></p>
                            <TextareaControl
                                value={description}
                                onChange={onDescriptionChange}
                                placeholder="Short description shown below the title"
                            />

                        </PanelBody>
                    </InspectorControls>

                    {/* Block preview */}
                    <a className="card card-destination">
                        <div className="card-img-top">
                            <img
                                className="cover-image"
                                src={image}
                                alt={alt}
                            />
                        </div>
                        <div className="card-body">
                            <div className="title-container half-pill-label">
                                <RichText
                                    tagName="h4"
                                    className="title"
                                    placeholder="TITLE"
                                    value={title}
                                    onChange={onTitleChange}
                                />
                                <RichText
                                    tagName="p"
                                    className="description"
                                    placeholder="Short description…"
                                    value={description}
                                    onChange={onDescriptionChange}
                                />
                            </div>
                        </div>
                    </a>
                </>
            );
        },

        /* Frontend rendering */
        save({ attributes }) {

            const { link, image, alt, title, description } = attributes;

            return (
                <a href={link} className="card card-destination">
                    <div className="card-img-top">
                        <img
                            className="lozad cover-image"
                            data-src={image}
                            alt={alt}
                        />
                        <div className="image-overlay"></div>
                    </div>
                    <div className="card-body">
                        <div className="title-container">
                            <h4 className="title">{title}</h4>
                            <p className="description">{description}</p>
                        </div>
                    </div>
                </a>
            );
        },
    });
}
